import {HttpErrorHandlingInterceptor} from "./http-error-handling-interceptor.service";
import {IHttpProvider} from "angular";

/* @ngInject */
export const genericHttpErrorHandler = ($httpProvider: IHttpProvider) => {
    $httpProvider.interceptors.push(HttpErrorHandlingInterceptor.factory);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/config/generic-http-handler.config.ts